<div class="w-screen h-screen py-4">
  <div class="h-full max-w-6xl mx-auto flex flex-col rounded overflow-hidden shadow-lg p-4">
    <div class="flex items-center text-2xl">
      <img class="max-w-xs w-24" src="../assets/angular.png" alt="Sunset in the mountains" />
      Angular Tailwind
    </div>
    <router-outlet></router-outlet>
  </div>
</div>